function FormInput({
  id,
  label,
  type,
  value,
  onChange,
  autoComplete = "",
  required = true,
  filterDigitsOnly = false,
  error,
  max,
}) {
  const handleChange = (e) => {
    let newValue = e.target.value;
    if (filterDigitsOnly) {
      newValue = newValue.replace(/[^0-9]/g, ""); // digits only
    }
    onChange(newValue);
  };

  return (
    <>
      <div className="sp-form-input-wrapper">
        <div className="sp-form-input">
          <input
            className={`form-input ${error ? "input-error" : ""}`}
            type={type}
            id={id}
            name={id}
            value={value}
            max={max}
            onChange={handleChange}
            autoComplete={autoComplete}
            required={required}
          />
          <label className="form-floating-label" htmlFor={id}>
            {label}
          </label>
        </div>
      </div>
      <div className="sp-validation-error">{error && <span>{error}</span>}</div>
    </>
  );
}

export default FormInput;
